export default {
      id: "ic-thumbs-up-usage",
      viewBox: "0 0 40 40",
      url: "/" + "images/icons.3.109.2.svg#ic-thumbs-up-usage",
      toString: function () {
        return this.url;
      }
    }